export const KPI_SUBCONTRACTOR = ({ processedDashboardData, targetSubcontractedProfit, theme }) => {
    return(
        <div style={{
            background: theme === 'light' ? '#fff' : '#333',
            padding: '20px',
            borderRadius: '12px',
            boxShadow: '0 6px 12px rgba(0,0,0,0.08)',
            border: '1px solid ' + (theme === 'light' ? '#e0e0e0' : '#555'),
            position: 'relative',
            overflow: 'hidden'
        }}>
            <div style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '4px',
                height: '100%',
                background: (processedDashboardData?.subcontractedKpis?.profitPercentage || 0) >= targetSubcontractedProfit ? '#28a745' : 
                            (processedDashboardData?.subcontractedKpis?.profitPercentage || 0) >= (targetSubcontractedProfit / 2) ? '#ffc107' : '#dc3545'
            }}></div>
            
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '20px' }}>
                <div>
                    <h4 style={{ color: '#6c757d', fontSize: '14px', fontWeight: '600', textTransform: 'uppercase', margin: '0 0 6px 0', letterSpacing: '0.5px' }}>
                        SUBCONTRACTED PROFIT MARGIN
                    </h4>
                    <div style={{ display: 'flex', alignItems: 'baseline', gap: '8px' }}>
                        <span style={{ 
                            fontSize: '36px', 
                            fontWeight: 'bold', 
                            color: (processedDashboardData?.subcontractedKpis?.profitPercentage || 0) >= targetSubcontractedProfit ? '#28a745' : 
                                    (processedDashboardData?.subcontractedKpis?.profitPercentage || 0) >= (targetSubcontractedProfit / 2) ? '#ffc107' : '#dc3545',
                            lineHeight: '1'
                        }}>
                            {processedDashboardData?.subcontractedKpis?.profitPercentage || 0}%
                        </span>
                    </div>
                </div>
                <div style={{
                    background: (processedDashboardData?.subcontractedKpis?.profitPercentage || 0) >= targetSubcontractedProfit ? 'rgba(40, 167, 69, 0.1)' : 
                                (processedDashboardData?.subcontractedKpis?.profitPercentage || 0) >= (targetSubcontractedProfit / 2) ? 'rgba(255, 193, 7, 0.1)' : 'rgba(220, 53, 69, 0.1)',
                    padding: '8px',
                    borderRadius: '8px',
                    fontSize: '18px'
                }}>
                    💰
                </div>
            </div>
            
            <div style={{ 
                fontSize: '14px', 
                color: theme === 'light' ? '#6c757d' : '#adb5bd',
                marginBottom: '12px'
            }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '4px' }}>
                    <span>Jobs this month:</span><span>{processedDashboardData?.subcontractedKpis?.jobsCount || 0}</span>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '4px' }}>
                    <span>Revenue:</span><span>£{processedDashboardData?.subcontractedKpis?.totalRevenue?.toFixed(2) || '0.00'}</span>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <span>Cost:</span><span>£{processedDashboardData?.subcontractedKpis?.totalCost?.toFixed(2) || '0.00'}</span>
                </div>
            </div>
            
            <div style={{ 
                fontSize: '12px', 
                color: (processedDashboardData?.subcontractedKpis?.profitPercentage || 0) >= targetSubcontractedProfit ? '#28a745' : 
                        (processedDashboardData?.subcontractedKpis?.profitPercentage || 0) >= (targetSubcontractedProfit / 2) ? '#ffc107' : '#dc3545',
                fontWeight: '600',
                textTransform: 'uppercase'
            }}>
                Target: ≥{targetSubcontractedProfit}% • {(processedDashboardData?.subcontractedKpis?.profitPercentage || 0) >= targetSubcontractedProfit ? 'ON TARGET' : 'BELOW TARGET'} • This Month
            </div>
        </div>
    )
}